export default "__VITE_ASSET__DmZePtIA__"